/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


const MOBILE_BREAKPOINT = 768;
const MAX_VISIBLE_SWATCHES_MOBILE = 7;
const MAX_VISIBLE_SWATCHES_DESKTOP = 10;

function handleSwatches() {
  const collection = document.querySelector('.template-collection');
  if (!collection) return;

  const productCards = collection.querySelectorAll('.product-card');
  const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

  const currentMaxSwatches = isMobile ? MAX_VISIBLE_SWATCHES_MOBILE : MAX_VISIBLE_SWATCHES_DESKTOP;

  productCards.forEach((card) => {
    const swatchWrapper = card.querySelector('.swatches .product-item__linked');
    if (!swatchWrapper) return;

    const swatches = Array.from(swatchWrapper.querySelectorAll('.product-item__linked-item'));

    const existingCountElements = swatchWrapper.querySelectorAll('.swatch-more-count');
    existingCountElements.forEach(el => el.remove());

    swatches.forEach(swatch => {
      swatch.classList.remove('swatch-hide');
    });

    if (swatches.length > currentMaxSwatches) {
      const extraCount = swatches.length - currentMaxSwatches;

      swatches.forEach((swatch, index) => {
        if (index >= currentMaxSwatches) {
          swatch.classList.add('swatch-hide');
        }
      });

      const countElement = document.createElement('a');
      countElement.href = swatchWrapper.dataset.url;
      countElement.classList.add('swatch-more-count');
      countElement.textContent = `+${extraCount}`;
      swatchWrapper.appendChild(countElement);
    }
  });
}

document.addEventListener('DOMContentLoaded', handleSwatches);
window.addEventListener('resize', handleSwatches);
